export default "__VITE_ASSET__D0NTgEBn__"